export function rawMaterialMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      rawMaterialId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateRawMaterialId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateRawMaterialId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyRawMaterial(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      rawMaterialId: resource.objectId,
    })),
  };
}

export function rawMaterialMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, rawMaterialId: json.result.objectId},
  };
}